import * as React from 'react';
import OutlinedDown from 'acud-icon/lib/icons/OutlinedDown';
import OutlinedUp from 'acud-icon/lib/icons/OutlinedUp';
import OutlinedLoading from 'acud-icon/lib/icons/OutlinedLoading';
import OutlinedCheck from 'acud-icon/lib/icons/OutlinedCheck';
import OutlinedClose from 'acud-icon/lib/icons/OutlinedClose';
export default function getIcons({ suffixIcon, clearIcon, menuItemSelectedIcon, removeIcon, loading, multiple, hasFeedback, prefixCls, triggerOpen, showArrow, feedbackIcon, }) {
    // Clear Icon
    let mergedClearIcon = clearIcon;
    if (!clearIcon) {
        mergedClearIcon = <OutlinedClose width="8px" height="8px"/>;
    }
    // Validation Feedback Icon
    const getSuffixIconNode = (arrowIcon) => (<>
            {showArrow !== false && arrowIcon}
            {hasFeedback && feedbackIcon}
        </>);
    // Arrow item icon
    let mergedSuffixIcon = null;
    if (suffixIcon !== undefined) {
        mergedSuffixIcon = getSuffixIconNode(suffixIcon);
    }
    else if (loading) {
        mergedSuffixIcon = getSuffixIconNode(<OutlinedLoading animation="spin"/>);
    }
    else {
        const iconCls = `${prefixCls}-suffix`;
        mergedSuffixIcon = () => {
            // if (open && showSearch) {
            //    return <OutlinedSearch className={iconCls} />;
            // }
            return getSuffixIconNode(triggerOpen ? <OutlinedUp className={iconCls}/> : <OutlinedDown className={iconCls}/>);
        };
    }
    // Checked item icon
    let mergedItemIcon = null;
    if (menuItemSelectedIcon !== undefined) {
        mergedItemIcon = menuItemSelectedIcon;
    }
    else if (multiple) {
        mergedItemIcon = <OutlinedCheck />;
    }
    else {
        mergedItemIcon = null;
    }
    let mergedRemoveIcon = null;
    if (removeIcon !== undefined) {
        mergedRemoveIcon = removeIcon;
    }
    else {
        mergedRemoveIcon = <OutlinedClose width="12px" height="12px"/>;
    }
    return {
        clearIcon: mergedClearIcon,
        suffixIcon: mergedSuffixIcon,
        itemIcon: mergedItemIcon,
        removeIcon: mergedRemoveIcon
    };
}
